import { useMutation, useQueryClient } from '@tanstack/react-query';
import { copyLocaleApi, type CopyLocaleRequest } from '../services/copy-locale';

export const useCopyLocale = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CopyLocaleRequest) => copyLocaleApi.copyRecommendations(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['activity-recommendations']
      });
    },
  });
};
